import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface OmnicommCredentials {
  login: string
  password: string
}

interface OmnicommState {
  credentials: OmnicommCredentials | null
  server: string | null
  setCredentials: (credentials: OmnicommCredentials) => void
  setServer: (server: string) => void
  clearCredentials: () => void
  clearServer: () => void
}

export const useOmnicommStore = create<OmnicommState>()(
  persist(
    (set) => ({
      credentials: null,
      server: null,

      setCredentials: (credentials: OmnicommCredentials) => {
        set({ credentials })
      },

      setServer: (server: string) => {
        set({ server })
      },

      clearCredentials: () => {
        set({ credentials: null })
      },

      clearServer: () => {
        set({ server: null })
      },
    }),
    {
      name: 'omnicomm-storage',
      partialize: (state) => ({
        credentials: state.credentials,
        server: state.server,
      }),
    }
  )
)
